import React from 'react';
import styled from 'styled-components';

const TableWrapper = styled.div`
  overflow-x: auto; /* Enable horizontal scrolling for wide tables */
  margin-bottom: 30px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Th = styled.th`
  background-color: #01A8CE;
  color: white;
  padding: 12px;
  text-align: left;
  white-space: nowrap; /* Prevent column headers from wrapping */
`;

const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #ddd;
  word-wrap: break-word; /* Allow wrapping for long text */
  max-width: 60px; /* Limit column width */
  text-overflow: ellipsis; /* Truncate overflowing text */
  overflow: hidden;
`;

const Tr = styled.tr`
  &:nth-child(odd) {
    background-color: #f9f9f9; /* Alternating row color */
  }

  &:hover {
    background-color: #f1f1f1; /* Highlight row on hover */
  }
`;

const CustomTable: React.FC<{ columns: Array<string>; data: Array<any> }> = ({
  columns,
  data,
}) => (
  <TableWrapper>
    <Table>
      <thead>
        <tr>
          {columns.map((col) => (
            <Th key={col}>{col}</Th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <Tr key={index}>
            {columns.map((col) => (
              <Td key={col}>{row[col]}</Td>
            ))}
          </Tr>
        ))}
      </tbody>
    </Table>
  </TableWrapper>
);

export default CustomTable;
